
function AnimationTitle(){

    this.build();

}

AnimationTitle.prototype.build = function(){

    document.querySelectorAll('.title-main').forEach(function (elem) {
        let splitText = new SplitText(elem, {
            type: "chars, words, lines"
        });

        splitText.chars.forEach(function (char, index){
            char.style.transitionDelay = 0.10 + index / 50 + 's';
        });

        $(window).on('transitionDone', function () {
            ScrollTrigger.create({
                trigger: elem,
                start: 'top 80%',
                once: true,
                onEnter: function () {
                    $(elem).addClass('appeared');
                }
            });
        });

    });

};
